import { render, staticRenderFns } from "./PushMessage.vue?vue&type=template&id=69d4cd77&"
import script from "./PushMessage.vue?vue&type=script&lang=js&"
export * from "./PushMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1983107846/src/bitbucket.org/atsuboi/chatbot/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69d4cd77')) {
      api.createRecord('69d4cd77', component.options)
    } else {
      api.reload('69d4cd77', component.options)
    }
    module.hot.accept("./PushMessage.vue?vue&type=template&id=69d4cd77&", function () {
      api.rerender('69d4cd77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/PushMessage/PushMessage.vue"
export default component.exports